/**
 * QuickTapsFeaturedPageV2 — redesigned shell for the Featured Quick
 * Taps reorder page. Not in the original prototype (cms-redesign-mockup.html)
 * because that file focuses on the list pages; this page reuses the
 * same primitives so it fits the design language:
 *
 *   • PageHeader with eyebrow "Quick Taps" + title "Featured"
 *   • Header action: "← Back to Quick Taps" → /quick-taps
 *   • InAppDescriptionPanel — inline editor for the in-app carousel
 *     intro (general_settings.quick_taps_featured_intro), per CMS
 *     feedback (Monday #12171251310 — it used to hide behind an
 *     "Update intro" modal). Reuses the existing v1 actions
 *     `fetchQuickTapsFeaturedIntro` / `updateQuickTapsFeaturedIntro`.
 *   • QuickTapsFeaturedTableV2 (drag-to-reorder list)
 */
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import QuickTapsFeaturedTableV2 from '../../QuickTapsTable/v2/QuickTapsFeaturedTableV2';
import {
  fetchQuickTapsFeaturedIntro,
  updateQuickTapsFeaturedIntro,
} from '../../../actions/quickTapsActions';
import { PageHeader, Button, InAppDescriptionPanel } from '../../redesign';

export default function QuickTapsFeaturedPageV2() {
  const dispatch = useDispatch();
  const intro = useSelector(
    (s) => s.general_data?.general_data?.quick_taps_featured_intro || '',
  );

  useEffect(() => {
    dispatch(fetchQuickTapsFeaturedIntro());
  }, [dispatch]);

  // Total chip — count of featured quick taps once loaded. The legacy
  // fetch writes to `state.quick_taps.all_quick_tap_sessions`, same
  // slice the table reads from.
  const featured = useSelector((s) => s.quick_taps.all_quick_tap_sessions);
  const totalLabel = Array.isArray(featured)
    ? `${featured.length.toLocaleString()} featured`
    : undefined;

  return (
    <div className="bg-bg min-h-full">
      <PageHeader
        eyebrow="Quick Taps"
        title="Featured"
        total={totalLabel}
        actions={
          <Link to="/quick-taps" className="no-underline">
            <Button variant="default" leadingIcon={<span aria-hidden>←</span>}>
              Back to Quick Taps
            </Button>
          </Link>
        }
      />
      <InAppDescriptionPanel
        tabName="Featured Quick Taps"
        value={intro}
        onSave={(value) => dispatch(updateQuickTapsFeaturedIntro(value))}
      />
      <QuickTapsFeaturedTableV2 />
    </div>
  );
}
